import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "@/pages/LoginPage";

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Entrar — AXIS Comprovantes" },
      {
        name: "description",
        content: "Acesse o AXIS Comprovantes com seu e-mail e um código de acesso de 6 dígitos.",
      },
      { property: "og:title", content: "Entrar — AXIS Comprovantes" },
      {
        property: "og:description",
        content: "Login seguro por e-mail e código OTP no AXIS Comprovantes.",
      },
    ],
  }),
  component: LoginRoute,
});

function LoginRoute() {
  const { redirect } = Route.useSearch();
  return <LoginPage redirect={redirect} />;
}
